import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export const initialState = () => {
  return {
    appTitle: 'QuickReceipts',
    user: null,
    error: null,
    loading: false,
    stripe: {
      status: {
        customer: {
          loading: true,
          processing: true,
        },
        subscription: {
          loading: true,
          processing: true,
        },
        card: {
          loading: true,
          processing: true,
        },
        invoices: {
          loading: true,
          processing: true,
        },
      },
      cards: {
        data: null,
        hasMore: true
      },
      customer: null,
      subscription: null,
      card: null,
      invoices: {
        data: null,
        hasMore: true
      },
    },
    receipts: {
      data: null,
      hasMore: true,
    },
  }
}

export const store = new Vuex.Store({
  state: initialState,
  mutations,
  actions,
  getters
})
